import { createTheme } from '@mui/material';
import {} from '@mui/material/colors';
import './App.css';

declare module '@mui/material/styles' {
	interface TypographyVariants {
		regular: React.CSSProperties;
		medium: React.CSSProperties;
		bold: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		regular?: React.CSSProperties;
		medium?: React.CSSProperties;
		bold?: React.CSSProperties;
	}
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides {
		regular: true;
		medium: true;
		bold: true;
	}
}

declare module '@mui/material/Chip' {
	interface ChipPropsColorOverrides {
		chipTertiary: true;
		chipPrimary: true;
		chipGreen: true;
		chipRed: true;
		chipGrey: true;
		chipLightGrey: true;
		chipFilledTertiary: true;
		chipPIRUser: true;
		chipCloth: true;
		chipFood: true;
		chipLive: true;
		chipWalk: true;
		chipCommunityWelfareInfo: true;
	}
}

declare module '@mui/material/styles/createPalette' {
	interface CommonColors {
		tertiary70: string;
		tertiary90: string;
		neutral20: string;
		neutral30: string;
		neutral40: string;
		neutral50: string;
		neutral70: string;
		neutral90: string;
	}

	interface Palette {
		chipPrimary: Palette['primary'];
		chipTertiary: Palette['primary'];
		chipGreen: Palette['primary'];
		chipRed: Palette['primary'];
		chipGrey: Palette['primary'];
		chipLightGrey: Palette['primary'];
		chipFilledTertiary: Palette['primary'];
		chipPIRUser: Palette['primary'];
		chipCloth: Palette['primary'];
		chipFood: Palette['primary'];
		chipLive: Palette['primary'];
		chipWalk: Palette['primary'];
		chipCommunityWelfareInfo: Palette['primary'];
	}

	interface PaletteOptions {
		chipPrimary?: PaletteOptions['primary'];
		chipTertiary?: PaletteOptions['primary'];
		chipGreen?: PaletteOptions['primary'];
		chipRed?: PaletteOptions['primary'];
		chipGrey?: PaletteOptions['primary'];
		chipLightGrey?: PaletteOptions['primary'];
		chipFilledTertiary?: PaletteOptions['primary'];
		chipPIRUser?: PaletteOptions['primary'];
		chipCloth?: PaletteOptions['primary'];
		chipFood?: PaletteOptions['primary'];
		chipLive?: PaletteOptions['primary'];
		chipWalk?: PaletteOptions['primary'];
		chipCommunityWelfareInfo?: PaletteOptions['primary'];
	}
}

export const mainTheme = createTheme({
	palette: {
		background: {
			default: '#F9F9FC',
		},
		common: {
			tertiary70: '#E09E36',
			tertiary90: '#FFDDB3',
			neutral20: '#212529',
			neutral30: '#495057',
			neutral40: '#5D5E61',
			neutral50: '#76777A',
			neutral70: '#AAABAE',
			neutral90: '#E2E2E5',
		},
		secondary: {
			main: '#F3950D',
		},

		// for Chip
		chipPrimary: {
			main: '#EBEFFF',
			light: '#EBEFFF',
			dark: '#EBEFFF',
			contrastText: '#1D2F99',
		},
		chipTertiary: {
			main: '#FEF1C7',
			light: '#FEF1C7',
			dark: '#FEF1C7',
			contrastText: '#D76F08',
		},
	},
	components: {
		MuiChip: {
			defaultProps: {
				size: 'small',
			},
			styleOverrides: {
				root: ({ ownerState }) => {
					if (ownerState.color === 'default') {
						return {
							backgroundColor: '#fff',
							color: '#343A40',
							border: '1px solid #ADB5BD',
						};
					}
					return {};
				},
			},
		},
		MuiButton: {
			defaultProps: {},
			styleOverrides: {
				root: {},
				textPrimary: {
					color: '#556AEB',
				},
				containedPrimary: {
					backgroundColor: '#F3950D',
					color: '#fff',
					'&:hover': {
						backgroundColor: '#F9B626',
					},
					'&.Mui-focused, &.Mui-active': {
						backgroundColor: '#F3950D',
					},
				},
			},
		},
		MuiIconButton: {
			defaultProps: {},
			styleOverrides: {
				root: {},
				colorPrimary: {
					color: '#F3950D',
				},
			},
		},
	},
});

export default mainTheme;
